import { useId } from 'react';

import { FieldLabel } from '@/shared/forms/FieldLabel';
import { Input } from '@/shared/ui/Input';

export function TextField({ label, error, hint, required, id: providedId, ...inputProps }) {
  const generatedId = useId();
  const id = providedId ?? generatedId;
  const descriptionId = error ? `${id}-error` : hint ? `${id}-hint` : undefined;

  return (
    <div className="grid gap-1.5">
      <FieldLabel htmlFor={id} required={required}>
        {label}
      </FieldLabel>
      <Input
        id={id}
        aria-invalid={Boolean(error)}
        aria-required={required ? 'true' : undefined}
        aria-describedby={descriptionId}
        {...inputProps}
      />
      {error ? (
        <p id={`${id}-error`} role="alert" className="text-sm text-red-600 dark:text-red-400">
          {error}
        </p>
      ) : hint ? (
        <p id={`${id}-hint`} className="text-sm text-[var(--app-muted)]">
          {hint}
        </p>
      ) : null}
    </div>
  );
}
